/**
* Created by vouill on 3/20/18.
*/

<template>
  <div class="wrapper">
    <div class="sub-footer">
      <router-link to="/contact">
        Contact
      </router-link>
    </div>
    <div class="container">
      <a
        href="https://www.facebook.com/metisassociation/"
        target="_blank"
        rel="noopener noreferrer"><facebook-logo/></a>
      <a
        href="https://metis-lab.com"
        target="_blank"
        rel="noopener noreferrer"><metis-logo/></a>
      <a
        href="https://twitter.com/rencontresmuseo"
        target="_blank"
        rel="noopener noreferrer"> <twitter-logo/></a>
      <a
        href="https://www.youtube.com/channel/UCAm3EWfaeKIK9qhjUPhXNTA/featured"
        target="_blank"
        rel="noopener noreferrer"> <youtube-logo/></a>
      <a
        href="https://www.linkedin.com/company/mêtis/"
        target="_blank"
        rel="noopener noreferrer"> <LinkedinLogo/></a>
      <a
        href="https://www.instagram.com/metis_association/"
        target="_blank"
        rel="noopener noreferrer"> <instagram-logo/></a>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.wrapper {
  padding: 3em 0 1em 0;
  text-align: center;
}
.sub-footer {
  margin-bottom: 1em;
  a {
    font-size: 12px;
    color: #999999;
    text-decoration: none;
  }
}
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  > * {
    margin: 0 0.5em;
  }
}
</style>

<script>
import MetisLogo from "../ui/metis-logo.vue";
import FacebookLogo from "../ui/facebook-logo";
import TwitterLogo from "../ui/twitter-logo";
import YoutubeLogo from "../ui/youtube-logo";
import InstagramLogo from "../ui/instagram-logo";
import LinkedinLogo from "../ui/linkedin-logo";

export default {
  name: "Footer",
  props: {},
  components: {
    MetisLogo,
    FacebookLogo,
    TwitterLogo,
    YoutubeLogo,
    InstagramLogo,
    LinkedinLogo
  },
  data() {
    return {};
  }
};
</script>
